module.exports = __webpack_public_path__ + "img/play.1e8fdac2.png";